import type { HtmlType } from '../../types.js'
import type { TsCodeType } from '../../types.js'
import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { LeafBlock } from '../leaf-block.js'
import { ScreenEditorInput } from '../decorators/screen-editor-input.js'
import { BoReference } from '../../bos/bo-reference.js'
import { Expression } from '../../data/text-or-code.js'

export const ImageLocationTypes = {
	resource: 'Resource',
	url: 'URL',
	base64: 'Base64-encoded data',
	arrayBuffer: 'ArrayBuffer',
}

@jsonClass('ImageBlock')
export class ImageBlock extends LeafBlock {
	@jsonProperty(String)
	@ScreenEditorInput({
		inputType: 'dropdown',
		order: 1,
		label: 'Image location',
		options: Object.entries(ImageLocationTypes),
	})
	locationType: keyof typeof ImageLocationTypes = 'resource'

	@jsonProperty(BoReference)
	@ScreenEditorInput({
		inputType: 'boRef',
		order: 1,
		label: 'Resource',
		allowedBoTypes: ['Resource'],
		includeImportedModules: true,
		isVisible: (blocks) => (blocks[0] as ImageBlock).locationType == 'resource',
		isMandatory: () => true,
	})
	resourceRef: BoReference = new BoReference()

	@jsonProperty(Expression)
	@ScreenEditorInput<ImageBlock>({
		inputType: 'code',
		order: 2,
		label: (blocks) =>
			`Content (${ImageLocationTypes[blocks[0].locationType]})`,
		codeLanguage: 'ts',
		tsReturnType: (blocks) =>
			blocks[0].locationType == 'arrayBuffer' ? 'ArrayBuffer' : 'string',
		editorSize: 'singleline',
		isBinding: false,
		isVisible: (blocks) => (blocks[0] as ImageBlock).locationType != 'resource',
		isMandatory: () => true,
	})
	contentCode = new Expression('')

	constructor(init: Partial<ImageBlock> = {}) {
		super()
		this.exampleText = 'Image'
		this.init(init)
	}

	producePreview(): HtmlType {
		switch (this.locationType) {
			case 'resource': {
				return `<img src="/${this.resourceRef.moduleId}/${this.resourceRef.moduleId}/${this.resourceRef.boId}" style="max-width: 250px;">`
			}
		}
		return `<div style="background: #dddddd; border: 1px solid #bbbbbb; padding: 3em;">${this.transpileExpressionForHtml(this.exampleText)}</div>`
	}

	getEditorCategory(): string {
		return 'Core'
	}
}
